/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Badge, Button, Divider, Drawer, Dropdown, Empty, Menu, Popover } from 'antd'
import React, { ReactComponentElement, useState } from 'react'
import { RiNotification3Line } from 'react-icons/ri';
import Logo from '../../components/Logo';
import { LuLayoutDashboard, LuLogOut, LuMenu } from 'react-icons/lu';
import { useRecoilValue } from 'recoil';
import appAtom from '../../atoms/app.atom';
import { useLocation, useNavigate } from 'react-router-dom';
import { BsGear } from 'react-icons/bs';
import { PiHeadset } from 'react-icons/pi';
import { useLogout } from '../../hooks/auth.hook';
import authAtom from '../../atoms/auth.atom';
import { handleCapitalize } from '../../contexts/Utils';
import { HiOutlineTicket, HiOutlineUserGroup } from 'react-icons/hi';
import { GrNavigate } from 'react-icons/gr';
import { width } from '../../contexts/Constants';
import { useGetProfile } from '../../hooks/settings.hook';

type Props = {
  children: ReactComponentElement<any>
}

function SecurityLayout({ children }: Props) {
  const { pathname } = useLocation();
  const { user } = useRecoilValue(authAtom)
  const { estate } = useRecoilValue(appAtom)
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const navigate = useNavigate();

  const { mutate: logoutAction, isLoading: logoutLoad } = useLogout();

  const items = [
    {
      label: 'Dashboard',
      key: '/security/dashboard',
      icon: <LuLayoutDashboard className="!text-lg" />,
    },
    {
      label: 'Gate Pass',
      key: '/security/pass',
      icon: <GrNavigate className="!text-lg" />,
    },
    {
      hide: true,
      label: 'Parking Ticket',
      key: '/security/ticket',
      icon: <HiOutlineTicket className="!text-lg" />,
    },
    {
      key: '/security/visitors',
      label: 'Visitors History',
      icon: <HiOutlineUserGroup className="!text-lg" />,
    },
  ].filter(({hide}) => !hide);

  const extras = [
    {
      label: 'Settings',
      key: '/security/settings',
      icon: <BsGear className="!text-lg" />,
    },
    {
      label: 'Contact Admin',
      key: '/security/contact',
      icon: <PiHeadset className="!text-lg" />,
    },
  ];

  const handleMenu = ({ key }: { key: string }) => navigate(key);
  const handleLogout = () => navigate('/auth/logout');

  const Notification = () => (
    <div className="bg-white p-5">
      <Empty />
    </div>
  );

  useGetProfile()
  return (
    <div className='w-full h-full bg-auth  bg-contain'>
      <div className='w-full md:w-[70%] h-full mx-auto bg-light'>
        <div className="w-full h-full overflow-y-auto scrollbar-thin">
          <div className="w-full sticky top-0 bg-white border-b border-outline flex justify-between items-end p-3 px-5 md:px-10 z-20">
            <div className="flex items-center gap-3">
              <Logo className="!w-[50px]" path="/security/dashboard" />
              <div className=''>
                <p className="text-base font-medium text-dark capitalize">{estate || "Estate Plus"}</p>
                <p className="text-xs font-normal text-gray">Security Staff</p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <Popover content={<Notification />}>
                <Badge dot>
                  <RiNotification3Line className="!text-xl" />
                </Badge>
              </Popover>
              <Button onClick={onOpen} icon={<LuMenu />} />
            </div>
          </div>
          <div className="w-full p-5 md:px-10 pb-20 md:pb-5">{children}</div>
        </div>
      </div>

      <Drawer
        open={isOpen}
        footer={false}
        closeIcon={false}
        onClose={onClose}
        classNames={{body: "!p-0"}}
        width={width <= 250 ? width : 250}
      >
        <div className="w-full h-full flex flex-col justify-between items-center py-5 px-2 relative">
          <div className="w-full max-h-[65vh] overflow-y-auto scrollbar-none">
            <Menu
              style={{
                border: 0,
                color: '#525866',
                fontSize: '14px',
                fontWeight: '400',
                background: 'transparent',
              }}
              defaultSelectedKeys={[pathname]}
              defaultOpenKeys={[pathname]}
              onClick={handleMenu}
              key="main-menu"
              mode="inline"
              items={items}
            />
          </div>

          <div className="w-full flex flex-col justify-center items-center">
            <Menu
              style={{
                border: 0,
                color: '#525866',
                fontSize: '14px',
                fontWeight: '400',
                background: 'transparent',
              }}
              defaultSelectedKeys={[pathname]}
              defaultOpenKeys={[pathname]}
              onClick={handleMenu}
              key="extra-menu"
              items={extras}
              mode="inline"
            />
            <Divider className="!my-2" />
            <div
              className={'w-full flex items-center px-3 '.concat(
                isOpen ? 'justify-center' : 'justify-between'
              )}
            >
              <div className="flex items-center gap-3">
                <Avatar alt="user" size="large" src={user?.profile_img}>
                  {handleCapitalize(user?.name?.[0])}
                </Avatar>
                <div className="w-[120px]">
                  <p title={user?.name} className="text-dark text-sm truncate">
                    {user?.name || 'FM User'}
                  </p>
                  <p title={user?.email} className="text-gray text-xs truncate">
                    {user?.email || 'fm-user@estateplus.com.ng'}
                  </p>
                </div>
              </div>
              <Dropdown trigger={["click"]} menu={{items: [
                {key: "normal", label: "Logout", onClick: logoutAction as any},
                {key: "clear", label: "Clear Cache & Logout", onClick: handleLogout},
              ]}}>
                <Button
                  type="text"
                  title="Logout"
                  loading={logoutLoad}
                  className="text-secondary !p-0 !m-0"
                  icon={<LuLogOut className="!text-lg !font-medium" />}
                />
              </Dropdown>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default SecurityLayout